module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/solution-02-dc4f9dfb49e3f3032e870db121a56291.jpg";